import MinimalSelectBox from '@sophocles/components/FormFields/MinimalSelectBox/MinimalSelectBox';

export default MinimalSelectBox;
